/**
 * applyBrand - hydrate per-tenant branding at startup. The editorial palette + teal-accent swap is
 * already driven by the static `data-tenant` attribute on <html> (see index.css [data-tenant=...] +
 * tailwind.config.ts addBase), so this loader is additive: it pins data-tenant and points the favicon
 * at the tenant asset. Non-fatal by design; a missing theme.json never blocks the app.
 */
interface Theme {
  tenant: string;
  logo?: string;
  favicon?: string;
  displayName?: string;
  tokens?: Record<string, string>;
}

function setFavicon(href: string): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}

export async function applyBrand(tenant: string): Promise<void> {
  try {
    document.documentElement.setAttribute('data-tenant', tenant);
    const res = await fetch(`/branding/${tenant}/theme.json`, { cache: 'no-store' });
    if (!res.ok) return;
    const theme = (await res.json()) as Theme;
    if (theme.favicon) setFavicon(theme.favicon);
  } catch {
    /* branding is non-critical; the static data-tenant attribute already themes the app */
  }
}
